import { createReducer, on } from '@ngrx/store';
import { OnboardingOrderOutIntegration, OnboardingOrderOutIntegrationForm } from '@core/models/integrations/orderOut';
import {
  INTEGRATION_FIND_SUCCESS,
  INTEGRATION_FAILURE,
  INTEGRATION_UPDATE_FORM,
  INTEGRATION_RESET_ERROR,
  INTEGRATION_RESET,
  INTEGRATION_RESET_FORM,
  INTEGRATION_FIND_ALL_SUCCESS,
  INTEGRATION_EDIT_MODE,
  INTEGRATION_CLEAR_STATE,
  INTEGRATION_UPDATE_LOADING,
  INTEGRATION_UPDATE_ID,
} from '@store/actions/integration.action';
import { ResponseBadRequest } from '@core/interfaces/response-bad-request';
import { transformOnboardingOrderOutData } from '@core/helpers';

export interface IntegrationState {
  loading: boolean;
  integrationList: OnboardingOrderOutIntegration[] | null;
  error: ResponseBadRequest | null;
  editMode: boolean;
  isEditing: boolean;
  integrationForm: OnboardingOrderOutIntegrationForm | null;
  integrationId: string | null;
  integration: OnboardingOrderOutIntegration | null;
}

export const initialState: IntegrationState = {
  loading: false,
  integrationList: null,
  error: null,
  editMode: false,
  isEditing: false,
  integrationForm: null,
  integrationId: null,
  integration: null,
};

export const integrationReducer = createReducer(
  initialState,
  on(INTEGRATION_EDIT_MODE, (state, { editMode, isEditing }) => ({ ...state, editMode, isEditing })),
  on(INTEGRATION_FIND_SUCCESS, (state, { integration }) => ({ ...state, integration: transformOnboardingOrderOutData(integration) })),
  on(INTEGRATION_FIND_ALL_SUCCESS, (state, { integrationList }) => ({ ...state, integrationList })),
  on(INTEGRATION_FAILURE, (state, { error }) => ({ ...state, error })),
  on(INTEGRATION_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(INTEGRATION_UPDATE_FORM, (state, { integrationForm }) => ({ ...state, integrationForm })),
  on(INTEGRATION_UPDATE_ID, (state, { integrationId }) => ({ ...state, integrationId })),
  on(INTEGRATION_RESET, (state) => ({ ...state, integration: null, integrationId: null, integrationForm: null })),
  on(INTEGRATION_RESET_ERROR, (state) => ({ ...state, error: null })),
  on(INTEGRATION_RESET_FORM, (state) => ({ ...state, integrationForm: null, loading: false })),
  on(INTEGRATION_CLEAR_STATE, () => initialState),
);
